import styled from 'styled-components';
import boardTop from 'assets/images/boardTop.min.png';
import lanternLeft from 'assets/images/lanternLeft.min.png';
import lanternRight from 'assets/images/lanternRight.min.png';

export const SHeader = styled.header`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: flex-start;
  height: var(--header-height);
  z-index: 10;

  [data-box='toasts'] {
    display: none;
    z-index: 100;
  }

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    [data-box='informer'] {
      display: flex;
    }

    [data-box='toasts'] {
      display: block;
      margin: 50px 0 0 -5px;
    }
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    [data-box='toasts'] {
      margin: 30px 0 0 -15px;
    }
  }
`;

export const SRoof = styled.span`
  position: absolute;
  background: none no-repeat 50% 100%;
  background-size: 100% auto;
  background-image: url('${boardTop}');
  width: calc(100% + 340px + 180px);
  height: 52px;
  bottom: -10px;
  right: -90px;
  pointer-events: none;

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: -30px;
    top: 30px;
    width: 105px;
    height: 700px;
    background-image: url('${lanternLeft}');
    background-position: 50% 50%;
    background-size: auto 700px;
    background-repeat: no-repeat;
  }

  &:after {
    left: auto;
    right: -75px;
    width: 180px;
    background-image: url('${lanternRight}');
    background-repeat: no-repeat;
  }

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    background: #f9f416;
    width: 100%;
    left: 0;
    height: 20px;
    border-radius: 15px 15px 0 0;

    &:before,
    &:after {
      display: none;
    }
  }
`;
